import filterConstants from '../constants';

const list = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.list,
  properties: {
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.type]: '',
    [filterConstants.PROPERTY.assignee]: '',
    [filterConstants.PROPERTY.status]: '',
    [filterConstants.PROPERTY.priority]: '',
    [filterConstants.PROPERTY.reporter]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.startDate]: '',
    [filterConstants.PROPERTY.endDate]: '',
    [filterConstants.PROPERTY.creationDate]: '',
    [filterConstants.PROPERTY.overdue]: '',
  },
});

export default list;
